import React from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  InputGroup,
  InputRightElement,
  IconButton
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

const FormInput = ({
  label,
  type = 'text',
  value,
  onChange,
  error,
  placeholder,
  isPassword = false,
  showPassword,
  onTogglePassword,
  ...props
}) => {
  return (
    <FormControl isInvalid={error}>
      <FormLabel>{label}</FormLabel>
      <InputGroup>
        <Input
          type={isPassword ? (showPassword ? 'text' : 'password') : type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...props}
        />
        {isPassword && (
          <InputRightElement>
            <IconButton
              icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
              variant="ghost"
              onClick={onTogglePassword}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            />
          </InputRightElement>
        )}
      </InputGroup>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};

export default FormInput;
